export default __webpack_public_path__ + "static/media/12025.f7427d9d.mp3";